export default {
      id: "reports_idling-usage",
      viewBox: "0 0 71 34",
      url: __webpack_public_path__ + "img/icons.svg#reports_idling",
      toString: function () {
        return this.url;
      }
    }